<template>
  <b>{{
    errorMsg ||
    "Ocurrió un error al cargar. Intente nuevamente o hable con el administrador por favor."
  }}</b>
  <button
    class="btn btn-sm btn-outline-dark ms-2"
    style="color: black"
    @click="$emit('reintentar')"
  >
    Reintentar
  </button>
</template>

<script setup>
const { errorMsg } = defineProps({
  errorMsg: { type: String, required: true },
});

defineEmits(["reintentar"]);
</script>
